import { useEffect, useState, useCallback } from 'react';
import { getEnvelopeMetricsBySociety } from 'modules/_shared/redux/envelopeActions';

type Metrics = {
  sentEnvelopes: number;
  pendingEnvelopes: number;
  declinedEnvelopes: number;
  completedEnvelopes: number;
  exceededMaxEnvelopes: boolean;
};

const initialState: Metrics = {
  sentEnvelopes: 0,
  pendingEnvelopes: 0,
  declinedEnvelopes: 0,
  completedEnvelopes: 0,
  exceededMaxEnvelopes: false,
};

export const useEnvelopesListSummarySection = (societyId?: string) => {
  const [metrics, setMetrics] = useState<Metrics>(initialState);
  const [isLoading, setIsLoading] = useState(false);
  const [isError, setIsError] = useState(false);

  const fetchMetrics = useCallback(async () => {
    if (!societyId) return;
    try {
      setIsLoading(true);
      setIsError(false);
      const data = await getEnvelopeMetricsBySociety(societyId);
      setMetrics(data);
    } catch (e) {
      setIsError(true);
      setMetrics(initialState);
    } finally {
      setIsLoading(false);
    }
  }, [societyId]);

  useEffect(() => {
    fetchMetrics();
  }, [fetchMetrics]);

  return {
    data: metrics,
    isLoading,
    isError,
    actions: { refetch: fetchMetrics },
  };
};

export default useEnvelopesListSummarySection;
